import React, { Component } from "react";
import { connect } from "react-redux";
import { loginUser, logoutUser } from "../modules/actions";
import { getUserData, getLoggingStatus, getisAuthenticated, getErrorMessage } from "../modules/reducers"



class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: "",
            password: "",
            hidden: true,
            error: "",
            usernameerror: "",
            passworderror: ""
        }
    }

    componentDidMount() {
        this.props.logout();
    }

    handleChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleshowhide(e) {
        e.preventDefault();
        this.setState({ hidden: !this.state.hidden });
    }

    componentDidUpdate(prevProps) {
        if (this.props.isAuthenticated) {
            this.props.history.push('/books');
        }
        if (prevProps.error !== this.props.error) {
            if (this.props.error !== "") {
                this.setState({
                    error: this.props.error
                })

            }
        }
    }

    handleSubmit = (e) => {
        if (this.state.username === "") {
            this.setState({
                usernameerror: 'Enter username'
            })

        } else if (this.state.password === "") {
            this.setState({
                passworderror: 'Enter Password'
            })

        }
        else {
            this.props.login(this.state.username, this.state.password);
        }

    }


    render() {
        return (
            <div className="loginpagebg" style={{
                backgroundImage: `url(${''})`,
            }} >
                <div className="account-pages pt-2 pt-sm-5 pb-4 pb-sm-5">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-xxl-4 col-lg-5">
                                <div className="card">
                                    <div className="card-body p-4">
                                        <div className="text-center w-75  m-auto">
                                            <h4 className="text-dark-50 text-center pb-0 fw-bold ">Dachepalli Admin Portal</h4>
                                        </div>
                                        <form action="#" onSubmit={(e) => { e.preventDefault(); this.handleSubmit(); }}>
                                            <div className="mb-3">
                                                <label htmlFor="username" className="form-label">Username</label>
                                                <input className="form-control" type="text" onChange={(e) => this.handleChange(e)} name="username" id="username" placeholder="Enter Username" autoComplete="off" />
                                            </div>
                                            {this.state.usernameerror ? <p className="erroremailpass" >{this.state.usernameerror}</p> : ''}
                                            <div className="mb-3" >

                                                <label htmlFor="password" className="form-label">Password</label>
                                             
                                                    <div className="input-group input-group-merge input-group-append">
                                                        <input type={this.state.hidden ? 'password' : 'text'} class="form-control" placeholder="Enter Password" onChange={(e) => this.handleChange(e)} name="password" id="passid" autoComplete="off"/>
                                                       
                                                            <button type="button" className="input-group-text showhide" onClick={(e) => this.handleshowhide(e)} id="showhide" >
                                                                {this.state.hidden ?
                                                                    <i className="uil-eye" aria-hidden="true"></i>
                                                                    : <i className="uil-eye-slash" aria-hidden="true"></i>
                                                                }
                                                            </button>
                                                        
                                                   
                                                    </div>
                                                
                                            </div>
                                            {this.state.passworderror ? <p className="erroremailpass" >{this.state.passworderror}</p> : ''}

                                            <p className="errorpara">{this.state.error}</p>
                                            <div className="mt-3 mb-3 text-center">
                                                <button className="btn btn-customprimary" type="submit"> Log In </button>
                                            </div>
                                        </form>
                                    </div> {/* end card-body */}

                                </div>
                                {/* end card */}

                                {/* end row */}
                            </div> {/* end col */}
                        </div>
                        {/* end row */}
                    </div>
                    {/* end container */}
                </div>
            </div>



        )

    }

}

const mapStateToProps = state => {
    return {
        user: getUserData(state),
        loggingStatus: getLoggingStatus(state),
        isAuthenticated: getisAuthenticated(state),
        error: getErrorMessage(state),
    }
}

const mapDispatchToProps = dispatch => ({
    login: (email, password) => dispatch(loginUser(email, password)),
    logout: () => dispatch(logoutUser()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);